'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useRouter, useSearchParams } from 'next/navigation'; // next/navigation에서 useRouter와 useSearchParams를 가져옵니다.

import { AuthApi, AuthQueryKey, UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { PolicyCard } from '@/components/molecule/PolicyCard';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/stores/AuthStore';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
import { PolicyBottomDrawer } from './PolicyBottomDrawer';
import { PolicyDialogContent } from './PolicyDialogContent';
interface PolicyContentProps {
  institutionId: number;
}
const POLICY_IDX_KEY = 'policyIdx';
export const PolicyContent = t0 => {
  const $ = _c(22);
  const {
    institutionId
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const pageSize = isDesktopViewport ? 3 : 4;
  const isLogin = useAuthStore(_temp);
  const queryKey = isLogin ? AuthQueryKey["get:/wello/v2/auth/home/institution/policy"]() : UnauthQueryKey["get:/wello/v2/allows/home/institution/policy"]();
  const {
    push
  } = useRouter();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get(POLICY_IDX_KEY) ?? undefined;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedPolicyIdIdx = t1;
  let t2;
  if ($[2] !== isDesktopViewport || $[3] !== push || $[4] !== searchParams) {
    t2 = policyIdx => {
      if (isDesktopViewport) {
        openResponsiveDialog({
          component: PolicyDialogContent,
          props: {
            policyIdIdx: policyIdx
          },
          modalHeader: {
            title: "\uC815\uCC45"
          },
          className: {
            modal: "max-w-[800px]"
          }
        });
      } else {
        const params = new URLSearchParams(searchParams?.toString());
        params.set(POLICY_IDX_KEY, policyIdx);
        push(`?${params.toString()}`, {
          scroll: false
        });
      }
    };
    $[2] = isDesktopViewport;
    $[3] = push;
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handlePolicyClick = t2;
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionTitle className={cn("mb-32", "mobile-tablet:mb-12")}>정책</SectionTitle>;
    t4 = cn("grid grid-cols-3 gap-x-18 gap-y-16", "mobile-tablet:grid-cols-1");
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mt-20")} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== institutionId || $[10] !== isLogin || $[11] !== pageSize) {
    t6 = t7 => {
      const {
        pageParam
      } = t7;
      return (isLogin ? AuthApi["get:/wello/v2/auth/home/institution/policy"] : UnauthApi["get:/wello/v2/allows/home/institution/policy"])({
        query: {
          institutionId,
          page: pageParam,
          size: pageSize
        }
      }).then(_temp2);
    };
    $[9] = institutionId;
    $[10] = isLogin;
    $[11] = pageSize;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handlePolicyClick) {
    t7 = item => <PolicyCard key={item.id} border={true} benefit={item.supportBenefit} bookmarkCount={item.wishlistCount} commentCount={item.commentCount} id={item.id} idIdx={item.metaPolicyIdIdx} imageUrl={item.agencyLogo} isBookmarked={item.wishlistYN} name={item.policyName} onClick={() => handlePolicyClick(item.metaPolicyIdIdx)} />;
    $[13] = handlePolicyClick;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = !!selectedPolicyIdIdx;
  let t9;
  if ($[15] !== push || $[16] !== searchParams) {
    t9 = () => {
      const params_0 = new URLSearchParams(searchParams?.toString() ?? "");
      params_0.delete(POLICY_IDX_KEY);
      push(`?${params_0.toString()}`, {
        scroll: false
      });
    };
    $[15] = push;
    $[16] = searchParams;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== selectedPolicyIdIdx || $[19] !== t8 || $[20] !== t9) {
    t10 = <PolicyBottomDrawer isOpened={t8} onClose={t9} policyIdIdx={selectedPolicyIdIdx} />;
    $[18] = selectedPolicyIdIdx;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return <><div>{t3}<div className={t4}><InfiniteListWithMoreButton moreButtonComponent={t5} queryKey={[...queryKey, institutionId, pageSize]} queryFn={t6} pageSize={pageSize} renderItem={t7} getItemKey={_temp3} /></div></div>{t10}</>;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(data) {
  return data.data?.context?.contents ?? [];
}
function _temp3(item_0) {
  return item_0.id;
}